export default __webpack_public_path__ + "static/media/tutorial3-4.ab948140.png";